"use client";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from "@cmp-src/primitives/collapsible";
import { parseISO } from "date-fns";
import React, { useMemo, useState } from "react";
import { IOfficesSchedulesIndexed, IQuestionnaire } from "@gettactic/api";
import { QuestionnaireReminder } from "@/features/dashboard/components/QuestionnaireReminder";
import { ReservationCardList } from "@/features/reservation/components/ReservationCard/ReservationCardList";
import { ReservationCardListDateTitle } from "@/features/reservation/components/ReservationCard/ReservationCardListDateTitle";
import { NotReservations } from "@/features/dashboard/components/reservations/NoReservations";

function DateCollapsible({
  date,
  scheduleMeData,
  embedded,
  setOpenReservationsPanel,
  onShowingAnotherModal
}: {
  date: string;
  scheduleMeData: IOfficesSchedulesIndexed;
  embedded: boolean;
  setOpenReservationsPanel?: React.Dispatch<React.SetStateAction<boolean>>;
  onShowingAnotherModal?: (showing: boolean) => void;
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="ml-1 mr-1">
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger>
          <ReservationCardListDateTitle open={open} date={parseISO(date)} />
        </CollapsibleTrigger>
        <CollapsibleContent>
          <ReservationCardList
            listType={"me-confirmed"}
            schedules={scheduleMeData.dates[date].filter((x) => !x.is_pending)}
            embedded={embedded}
            setOpenReservationsPanel={setOpenReservationsPanel}
            onShowingAnotherModal={onShowingAnotherModal}
          />
          <ReservationCardList
            listType={"me-pending"}
            schedules={scheduleMeData.dates[date].filter((x) => x.is_pending)}
            embedded={embedded}
            setOpenReservationsPanel={setOpenReservationsPanel}
            onShowingAnotherModal={onShowingAnotherModal}
          />
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}

type Props = {
  embedded?: boolean;
  questionnaireData: IQuestionnaire | null;
  officeId: string | null;
  scheduleMeData: IOfficesSchedulesIndexed | null;
  setOpenReservationsPanel?: React.Dispatch<React.SetStateAction<boolean>>;
  onShowingAnotherModal?: (showing: boolean) => void;
};

export function TabConfirmed({
  embedded = false,
  questionnaireData,
  officeId,
  scheduleMeData,
  setOpenReservationsPanel,
  onShowingAnotherModal
}: Props) {
  const meSchedulesList = useMemo(() => {
    const all =
      officeId && scheduleMeData && scheduleMeData?.dates
        ? Object.keys(scheduleMeData?.dates)
        : [];
    all.sort();
    return all;
  }, [officeId, scheduleMeData]);
  return (
    <>
      {questionnaireData &&
      questionnaireData.is_mandatory &&
      questionnaireData.can_respond &&
      !questionnaireData.is_passed ? (
        <QuestionnaireReminder
          embedded={embedded}
          is_passed={questionnaireData.is_passed}
          can_update={questionnaireData.can_update}
          maximum_minutes_grace_period={
            questionnaireData.maximum_minutes_grace_period
          }
        />
      ) : null}
      {meSchedulesList.length && officeId && scheduleMeData ? (
        <>
          {meSchedulesList.map((date) => (
            <DateCollapsible
              key={date}
              date={date}
              scheduleMeData={scheduleMeData}
              embedded={embedded}
              setOpenReservationsPanel={setOpenReservationsPanel}
              onShowingAnotherModal={onShowingAnotherModal}
            />
          ))}
        </>
      ) : (
        <NotReservations />
      )}
    </>
  );
}
